import React from "react";
import content from "../content/content.json";

const NavBar = ({ capabilities, industries, insights, about }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [hoveredItem, setHoveredItem] = React.useState(null);
  const { navBar } = content;

  const handleHover = (key) => setHoveredItem(key);
  const handleLeave = () => setHoveredItem(null);

  return (
    <nav className="relative bg-white shadow-sm z-50" onMouseLeave={handleLeave}>
      <div className="flex justify-between items-center py-4 px-8">
        <div className="flex items-center space-x-6">
          <a href="/" className="text-red-600 font-extrabold text-3xl cursor-pointer">
            {navBar.logo}
          </a>

          <ul className="hidden md:flex space-x-6 text-gray-800 font-medium items-center px-3">
            {navBar.navItems.map((item) => (
              <li
                key={item.key}
                onMouseEnter={() => handleHover(item.key)}
                className="cursor-pointer capitalize"
              >
                <a href={item.href} className="hover:text-gray-600">
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:hidden">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="text-gray-800 focus:outline-none"
            aria-label={navBar.menuAriaLabel}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              {isOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        <div className="hidden md:flex items-center space-x-6 text-sm font-medium text-gray-700">
           {navBar.rightLinks.map((item) => (
              <li
                key={item.key}
                onMouseEnter={() => handleHover(item.key)}
                className="cursor-pointer capitalize"
              >
                <a href={item.href} className="hover:text-gray-600">
                  {item.label}
                </a>
              </li>
            ))}
        
          <div className="border-l border-gray-300 h-5"></div>
          <a href="#" className="flex items-center space-x-1 font-semibold">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 text-gray-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 2a10 10 0 100 20 10 10 0 000-20zM2 12h20M12 2c2.5 2.5 2.5 17.5 0 20M12 2C9.5 4.5 9.5 19.5 12 22"
              />
            </svg>
            <span>{navBar.global}</span>
          </a>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <ul className="flex flex-col px-8 pb-4 space-y-3 bg-white border-t border-gray-100 text-gray-800 font-medium">
          {navBar.navItems.map((item) => (
            <li key={item.key}>
              <a href={item.href} className="block py-2 hover:text-red-600 capitalize" onClick={() => setIsOpen(false)}>
                {item.label}
              </a>
            </li>
          ))}
          <li className="border-t border-gray-100 pt-3 space-y-3">
            {navBar.rightLinks.map((item) => (
              <a key={item.key} href={item.href} className="block py-1 hover:text-red-600 capitalize text-sm text-gray-600" onClick={() => setIsOpen(false)}>
                {item.label}
              </a>
            ))}
          </li>
        </ul>
      </div>

      {/* Desktop mega-menu dropdown */}
      <div
        className={`absolute top-full left-0 w-full z-40 transition-all duration-500 ease-in-out transform ${
          hoveredItem
            ? "opacity-100 translate-y-0 pointer-events-auto"
            : "opacity-0 -translate-y-4 pointer-events-none"
        }`}
      >
        {hoveredItem && (
          <div>
            {hoveredItem === "capabilities" && capabilities}
            {hoveredItem === "industries" && industries}
            {hoveredItem === "insights" && insights}
            {hoveredItem === "about" && about}
          </div>
        )}
      </div>
    </nav>
  );
};

export default NavBar;

